import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useGetAccountQuery, AccountCategory } from '~/types/types'
import { useVentureId } from '~/functions/accounts'


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioVentureNoUsersBanner',
  setup(__props) {

const ventureId = useVentureId()

const { result: sessionResult } = useGetAccountQuery()

const isPortfolioSession = computed(
  () => sessionResult.value?.getAccount?.type === AccountCategory.Portfolio,
)

const { result: ventureResult } = useGetAccountQuery(
  computed(() => ({ id: ventureId.value })),
  computed(() => ({
    enabled: isPortfolioSession.value && Boolean(ventureId.value),
  })),
)

const showBanner = computed(
  () =>
    isPortfolioSession.value &&
    (ventureResult.value?.getAccount?.usersCount ?? 0) === 0,
)

return { __sfc: true,ventureId, sessionResult, isPortfolioSession, ventureResult, showBanner }
}

})